import React, { useContext } from 'react';
import { LanguageContext } from '../contexts/LanguageContext';

const LanguageToggle = () => {
  const { language, toggleLanguage, translations } = useContext(LanguageContext);
  
  return (
    <button 
      onClick={toggleLanguage}
      aria-label={translations['toggle.language']}
      className="p-2 rounded-full transition-colors duration-300 hover:bg-gray-200 dark:hover:bg-gray-700"
      title={translations['toggle.language']}
    >
      {language === 'en' ? (
        <span className="flex items-center justify-center w-5 h-5 font-bold text-blue-700 dark:text-blue-400">FR</span>
      ) : (
        <span className="flex items-center justify-center w-5 h-5 font-bold text-blue-700 dark:text-blue-400">EN</span>
      )}
    </button>
  );
};

export default LanguageToggle;
